import AuthModel from './AuthModel';
import CrudModel from './CrudModel';
import FormModel from './FormModel';
import FilterModel from './FilterModel';
import GlobalModel from './GlobalModel';
import ProductModel from './ProductModel';
import OrderModel from './OrderModel';
import CategoryModel from './CategoryModel';
import LogModel from './LogModel';
import UserModel from './UserModel';
import HomeModel from './HomeModel';

const Auth = new AuthModel({
  model: 'auth',
});

const Product = new ProductModel({
  url: '/rest/store_product',
  model: 'product',
});

const Dashboard = new CrudModel({
  url: '/rest/store_product',
  model: 'dashboard',
});

const Order = new OrderModel({
  url: '/rest/order',
  model: 'order',
});

const Category = new CategoryModel({
  url: '/rest/store_category',
  model: 'category',
});

const Log = new LogModel({
  url: '/rest/log/list',
  model: 'log',
});

const User = new UserModel({
  url: '/rest/store_admin',
  model: 'user',
});

const Filter = new FilterModel({
  model: 'filter',
});

const Form = new FormModel({
  url: '/api/core/form',
  model: 'form',
  initialState: {
    forms: {},
    isLoading: false,
    isError: false,
    errorMessage: '',
  },
});

const Home = new HomeModel({
  url: '/rest/home',
  model: 'home',
});

const Global = new GlobalModel({
  model: 'global',
});

export {
  Auth,
  User,
  Filter,
  Form,
  Global,
  Product,
  Dashboard,
  Order,
  Category,
  Log,
  Home,
};



// WEBPACK FOOTER //
// ./src/models/index.js